module.exports = __webpack_public_path__ + "img/unbind.24b7f7e6.svg";